import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';

import { formatLargeNumber, hasFollowers } from 'utils/helpers';
import styles from 'styles/components/gigs/Gig.module.scss';

const NetworksWithFollowers = ({ profile, newStyles, hideOnMobile }) => (
  <div className={clsx(styles.profileNetworks, { [newStyles?.networks]: !isEmpty(newStyles) })}>
    {profile?.influencer_networks
      ?.filter(
        influencerNetwork =>
          influencerNetwork.network.name !== 'Image & Likeness' &&
          influencerNetwork.profile_screenshot_status === 'verified' &&
          influencerNetwork.active
      )
      .map(influencerNetwork => (
        <div
          className={clsx(styles.network, { [newStyles?.network]: !isEmpty(newStyles) })}
          key={influencerNetwork.id}
        >
          <Image
            src={influencerNetwork.network.active_icon_url}
            width={16}
            height={16}
            alt={influencerNetwork.network.name}
            unoptimized
          />

          {hasFollowers(influencerNetwork) && (
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <span>{formatLargeNumber(influencerNetwork.max_followers)}</span>

              {influencerNetwork.top_creator_percentage > 0 && !hideOnMobile && (
                <h6 className="color-main" style={{ fontSize: 13, margin: '0 5px' }}>
                  (Top {influencerNetwork.top_creator_percentage}%)
                </h6>
              )}
            </div>
          )}
        </div>
      ))}
  </div>
);

NetworksWithFollowers.propTypes = {
  profile: PropTypes.object.isRequired,
  newStyles: PropTypes.object,
  hideOnMobile: PropTypes.bool,
};

NetworksWithFollowers.defaultProps = {
  newStyles: {},
  hideOnMobile: false,
};

export default NetworksWithFollowers;
